import type { UpdateReportConfigurationRequestType } from 'src/api/generated/touring/types';
import type { EditReportMailingFormValuesType } from '../../types';

export const mapFormValuesToUpdateRequest = (
  values: EditReportMailingFormValuesType
): UpdateReportConfigurationRequestType => ({
  label: values.label.trim(),
  isEnabled: values.isEnabled,
  sendWeekday: values.sendWeekday,
  sendTime: `${values.sendHour}:${values.sendMinute}`,
  locale: values.locale,
  configurationOptions: {
    kind: 'PERSON',
    scope: values.scope,
    includeRevenue: values.includeRevenue,
    recipientMail: values.recipientMail,
  },
  profileNote: values.profileNote.trim() || null,
  internalNote: values.internalNote.trim() || null,
});
